import {
  Box,
  Button,
  Card,
  CardMedia,
  Typography,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
type CardHeroProps = {
  title: string;
  image: string;
  alt: string;
  currency: string;
  ref?: (el: HTMLDivElement | null) => void;
  to: string;
  price: string;
  description: string;
};
export const CardHero = ({
  title,
  image,
  currency,
  price,
  ref,
  to,
  description,
  alt,
}: CardHeroProps) => {
  const theme = useTheme();
  return (
    <Card
      ref={ref}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderRadius: 5,
        backgroundColor: "#000000",
        maxHeight: 500,
        padding: 5,
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#090909 ",
          "&:hover .card-final-image": {
            transform: "scale(0.95)",
          },
          "&:hover .image-shadow": {
            boxShadow: "#090909 0px -70px 26px -28px inset",
          },
        },
      }}
    >
      <Link to={to} style={{ textDecoration: "none" }}>
        <Box position="relative" width="100%" height={{ xs: 200, lg: 325 }}>
          <CardMedia
            className="card-final-image"
            component="img"
            src={image}
            alt={alt}
            sx={{
              width: "100%",
              objectFit: "cover",
              transition: "transform  0.3s ease-out",
              height: "100%",
              borderRadius: 5,
            }}
          />
          <Box
            className="image-shadow"
            sx={{
              position: "absolute",
              top: 0,
              width: "100%",
              height: "100%",
              boxShadow: "black 0px -70px 26px -28px inset",
            }}
          />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={3}
        >
          <Typography
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              textWrap: "nowrap",
              maxWidth: { xs: 100, sm: 150, md: 200 },
              fontSize: {
                xs: 12,
                md: 17,
              },
              textAlign: "center",
              color: theme.palette.background.default,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              textWrap: "nowrap",
              color: theme.palette.background.paper,
              fontSize: {
                xs: 10,
                md: 13,
              },
            }}
            maxWidth={{ xs: 150, md: 300 }}
            textAlign="center"
            variant="body2"
          >
            {description}
          </Typography>
          <Typography
            sx={{
              color: theme.palette.background.paper,
              fontSize: {
                xs: 10,
                md: 13,
              },
            }}
            maxWidth={{ xs: 150, md: 300 }}
            textAlign="center"
            variant="body2"
          >
            {currency}
            {price}
          </Typography>
          <Button
            variant="contained"
            sx={{
              minWidth: 0,
              margin: 0,
              padding: "17px 10px",
              lineHeight: 0,
              borderRadius: "100vmax !important",
            }}
          >
            Buy
          </Button>
        </Box>
      </Link>
    </Card>
  );
};
